module.exports = __webpack_public_path__ + "img/img6322.050de69d.jpg";